// Shows two lines: "Last reconciled N days ago" (or "Not yet reconciled")
// AND, when the user has a streak of one or more ISO weeks in a row, a
// small "🔥 N week streak" badge that turns weekly balance updates into a
// habit-forming ritual. The streak grace-periods the current week — if the
// user reconciled last week but not yet this week, streak stays intact
// through Sunday.
export default function ReconcileStalenessPill({ lastAt, streak }) {
  const days = lastAt
    ? Math.max(0, Math.floor((new Date() - new Date(lastAt)) / 86400000))
    : null;
  const label = days === null
    ? "Not yet reconciled"
    : days === 0
      ? "Last reconciled today"
      : `Last reconciled ${days} day${days === 1 ? "" : "s"} ago`;
  const cls = days === null
    ? "text-[#8A918D]"
    : days >= 7
      ? "text-[#8C3A30] font-medium"
      : days >= 3
        ? "text-[#8C5D30]"
        : "text-[#8A918D]";
  return (
    <div className="mt-0.5 flex items-center gap-2 flex-wrap" data-testid="cpp-reconcile-staleness">
      <div className={`text-[11px] ${cls}`}>{label}</div>
      {streak > 0 && (
        <div
          className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold bg-[#FEF3C7] text-[#7A4E1F] border border-[#F0DDA0]"
          data-testid="reconcile-streak-badge"
          title={`You've reconciled ${streak} week${streak === 1 ? "" : "s"} in a row — keep it going!`}
        >
          <span aria-hidden="true">🔥</span>
          {streak} week{streak === 1 ? "" : "s"} in a row
        </div>
      )}
    </div>
  );
}
